module.exports = __webpack_public_path__ + "img/00037.20525f1b.webp";